import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getEquipmentFactplaces(companyId, equipmentId) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT_FACTPLACES,dtConfig[ModulesMap.EQUIPMENT_FACTPLACES].getEquipmentFactplaces, {
		urlParams: {
			companyId,
			equipmentId,
		},
	})
}
function getEquipmentFactplace(companyId, equipmentId, factplaceId) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT_FACTPLACES,dtConfig[ModulesMap.EQUIPMENT_FACTPLACES].getEquipmentFactplace, {
		urlParams: {
			companyId,
			equipmentId,
            factplaceId,
		},
	})
}

function createEquipmentFactplace(companyId, equipmentId, data) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT_FACTPLACES,dtConfig[ModulesMap.EQUIPMENT_FACTPLACES].createEquipmentFactplace, {
		urlParams: {
			companyId,
            equipmentId,
		},
		...data,
	})
}

function patchEquipmentFactplace(companyId, equipmentId, factplaceId, data) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT_FACTPLACES,dtConfig[ModulesMap.EQUIPMENT_FACTPLACES].patchEquipmentFactplace, {
		urlParams: {
			companyId,
			equipmentId,
            factplaceId,
		},
		...data,
	})
}

function putEquipmentFactplace(companyId, equipmentId, factplaceId, data) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT_FACTPLACES,dtConfig[ModulesMap.EQUIPMENT_FACTPLACES].putEquipmentFactplace, {
		urlParams: {
			companyId,
			equipmentId,
            factplaceId,
		},
		...data,
	})
}

function deleteEquipmentFactplace(companyId, equipmentId, factplaceId) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT_FACTPLACES,dtConfig[ModulesMap.EQUIPMENT_FACTPLACES].deleteEquipmentFactplace, {
		urlParams: {
			companyId,
			equipmentId,
            factplaceId,
		},
	})
}

export default {
    getEquipmentFactplaces,
    getEquipmentFactplace,
    createEquipmentFactplace,
    patchEquipmentFactplace,
    putEquipmentFactplace,
    deleteEquipmentFactplace,
}
